import React, { createContext, useState, ReactNode } from 'react';
import { UserPermisos } from "../model/UserPermisos";
import { AlumneInfo, DefaultAulumneInfo } from "../model/AlumneInfo";

export const AuthContext = createContext<{
    isLoggedIn: boolean;
    userId: string;
    user: UserPermisos;
    userPermisos: UserPermisos[];
    alumne: AlumneInfo;
    breadcrumb: any[];
    setLoggedIn: (loggedIn: boolean) => void;
    setUserId: (loggedIn: string) => void;
    setUser: (loggedIn: UserPermisos) => void;
    setAlumneInfo: (alumne: AlumneInfo) => void;
    setBreadCrumb: (nuevo: any, anadir: boolean) => void;
    setUserPermisos: (nuevo: any) => void;
}>({
    isLoggedIn: false,
    userId: '',
    user: { "id": -1, "titol": "", "accio": "", "tipus": "" },
    userPermisos: [],
    alumne: DefaultAulumneInfo,
    breadcrumb: ['Home'],
    setLoggedIn: () => { },
    setUserId: () => { },
    setUser: () => { },
    setAlumneInfo: () => { },
    setBreadCrumb: () => { },
    setUserPermisos: () => { },
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const safelyParse = (key: string, fallback: any) => {
        const stored = localStorage.getItem(key);
        if (!stored || stored === 'undefined' || stored === 'null') return fallback;
        try {
            return JSON.parse(stored);
        } catch (e) {
            console.error(`Error parsing ${key} from localStorage:`, e);
            return fallback;
        }
    };

    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => localStorage.getItem('isLoggedIn') === 'true');
    const [userId, setUserIdState] = useState<string>(() => localStorage.getItem('userId') || '');
    const [userPermisos, setUserPermisosState] = useState<any[]>(() => safelyParse('userPermisos', []));
    const [alumne, setAlumneInfoState] = useState<AlumneInfo>(() => safelyParse('alumneInfo', DefaultAulumneInfo));
    const [breadcrumb, setBreadCrumb] = useState([{ nom: 'Home', nav: '/home' }]);
    const [user, setUserState] = useState<UserPermisos>(() =>
        safelyParse('user', { "id": -1, "titol": "", "accio": "", "tipus": "" })
    );

    const setLoggedIn = (loggedIn: boolean) => {
        setIsLoggedIn(loggedIn);
        if (loggedIn) localStorage.setItem('isLoggedIn', 'true');
        else {
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('authToken');
        }
    };

    const setUserId = (id: string) => {
        setUserIdState(id);
        localStorage.setItem('userId', id);
    };

    const setUser = (u: UserPermisos) => {
        setUserState(u);
        localStorage.setItem('user', JSON.stringify(u));
    };

    const setUserPermisos = (permisos: any) => {
        setUserPermisosState(permisos);
        localStorage.setItem('userPermisos', JSON.stringify(permisos));
    };

    const setAlumneInfo = (info: AlumneInfo) => {
        setAlumneInfoState(info);
        try {
            localStorage.setItem('alumneInfo', JSON.stringify(info));
        } catch (e) {
            console.warn("localStorage quota exceeded for alumneInfo. Attempting to save without avatar.", e);
            try {
                // Remove avatar which is likely a large base64 string causing the quota issue
                const strippedInfo = { ...info, alumne: { ...info.alumne, avatar: "" } };
                localStorage.setItem('alumneInfo', JSON.stringify(strippedInfo));
            } catch (e2) {
                console.error("Still exceeding quota after stripping avatar.", e2);
            }
        }
    };

    const addBreadCrumb = (nuevo: any, anadir: boolean) => {
        setBreadCrumb(nuevo);
    };

    return (
        <AuthContext.Provider value={{ userPermisos, setUserPermisos, isLoggedIn, userId, setLoggedIn, setUserId, user, setUser, alumne, setAlumneInfo, breadcrumb, setBreadCrumb: addBreadCrumb }}>
            {children}
        </AuthContext.Provider>
    );
};
